// Copyright (c) Hamilton Manufacturing Corp.

import React, { useEffect } from 'react';
import {
    Routes,
    Route,
    useLocation,
    Navigate,
} from 'react-router-dom';
import { useGlobalState } from '../globalState/GlobalStateProvider';
import LogIn from '../../_pwa/pages/LogIn';
import SignUp from '../../_pwa/pages/SignUp';
import MenuRoutes from '../../_pwa/MenuRoutes';
import { generateId } from '../api/utility';
import Layout from '../../_pwa/pageLayout/Layout';
import Disabled from '../../_pwa/pages/Disabled';
import PasswordRecovery from '../../_pwa/pages/PasswordRecovery';
import StoreDirect from '../../_pwa/pages/StoreDirect';
import Heading from '../form/Heading';
import Card from '../../_pwa/Card';
import Title from '../form/Title';

const ScrollToTop = ({ children, location }) => {
    React.useEffect(() => document.querySelector('#content_wrapper').scrollTo(0, 0), [location]);
    return children;
};

const MobileRouter = () => {
    useLocation();
    const { state: {
        active_user,
        app_key,
    } } = useGlobalState();

    if (!app_key) {
        return <Navigate to="/" replace />;
    }
    const routes = MenuRoutes();

    if (window !== window.top && window.frameElement && window.top.location.pathname.includes('Mac')) {
        window.location.hash = '#MAC';
    }

    return (
        <ScrollToTop location={window.location.pathname}>
            <Layout>
                <Routes>
                    {
                        active_user.isLoggedIn ?
                            <>
                                {
                                    Object.entries(routes)
                                        .map(([key, value]) => value)
                                        .filter(e => !e.disabled)
                                        .map(e => <Route key={generateId()} path={e.route} element={e.element} />)
                                }
                                <Route path='*' element={<Disabled />} />
                                <Route path='/storeDirect' element={(
                                    <Card>
                                        <Title icon='exclamationTriangle'>Account Already Created</Title>
                                        We're sorry, you have already created an account and are unable to add a referral code.
                                    </Card>
                                )} />
                            </> :
                            active_user.isGuestUser ?
                                <>
                                    {
                                        Object.entries(routes)
                                            .map(([key, value]) => value)
                                            .filter(e => !e.disabled)
                                            .filter(e => e.isGuestUser === true)
                                            .map(e => <Route key={generateId()} path={e.route} element={e.element} />)
                                    }
                                    <Route path='/storeDirect' element={<StoreDirect />} />
                                    <Route path='*' element={<LogIn />} />
                                </> :
                                <>
                                    <Route path='/' element={<LogIn />} />
                                    <Route path='/signUp' element={<SignUp />} />
                                    <Route path='/passwordRecovery' element={<PasswordRecovery />} />
                                    <Route path='/storeDirect' element={<StoreDirect />} />
                                    <Route path='*' element={<Navigate to="/" replace />} />
                                </>
                    }
                </Routes>
            </Layout>
        </ScrollToTop>
    );
}

export default MobileRouter;
